/**
 * Copyright (C) 2019 User X, LLC http://whoisuserx.com <info@userx.co>
 *
 * This program is the intellectual property of User X, LLC. You may
 * not redistribute and/or modify it without written consent by controlling
 * entities of User X, LLC.
 *
 * You should have received a copy of our Web Developer Agreement which
 * outlines proper use and distribution of this program. If you did not
 * please email info@userx.co to request your copy.
 */
/**
 * File created by John M. Woodcock < john@userx.co >
 * on 7/18/2025
 * for userx-support
 */

import React, {useEffect, useState} from "react";
import SelectorInput from "./SelectorInput";
import {search} from "../../../_utilities/reactUtils";
import {TICKET_TYPES} from "../../../system/defaults";
import supportAPI from "../../../_apis/supportAPI";
import useDefaultsManager from "../../../_hooks/useDefaultsManager";

const TypeAssignments = ({company_id = null}) => {
    const types = useDefaultsManager('type-defaults');
    const [agentList, setAgentList] = useState(null);
    const [assignments, setAssignments] = useState({});
    const [saveConfirm, setSaveConfirm] = useState(false);

    useEffect(() => {
        types.fetchDefaults();
        search('contact', [`group_id IN (1,2,3,4)`]).then(response => {
            // console.log('Ticket::refresh', 'agentList', response);
            setAgentList(response)
        });

        if (!company_id) {
            supportAPI.get(`/options/type_assignments`).then(response => {
                if (response.data?.option_value) {
                    const parsed = JSON.parse(response.data.option_value);
                    try {
                        setAssignments(parsed);
                    } catch (e) {
                        console.error('Failed to parse type_assignments JSON', e);
                    }
                }
            });
        } else {
            supportAPI.get(`/company/${company_id}/meta/type_assignments`).then(response => {
                if (response.data?.[0]?.meta_value) {
                    try {
                        const parsed = JSON.parse(response.data[0].meta_value);
                        setAssignments(parsed);
                    } catch (e) {
                        console.error('Failed to parse type_assignments JSON', e);
                    }
                }
            });
        }
    }, []);

    const getOptions = () =>
        agentList.map(agent => ({
            label: `${agent.first_name} ${agent.last_name}`,
            value: agent.contact_id
        }));

    const handleChange = (typeKey, value) => {
        setAssignments(prev => ({...prev, [typeKey]: value}));
    };

    const handleSubmit = () => {
        setSaveConfirm(false);
        if (company_id) {
            const data = {
                company_id: company_id,
                meta_key:   'type_assignments',
                meta_value: JSON.stringify(assignments)
            };
            console.log('TypeAssignments::save',data);
            supportAPI.put(`/company/${company_id}/meta/type_assignments`, data).then(response => {
                console.log('Type Assignments saved', response);
                setSaveConfirm(true);
            }).catch(err => console.error(err));
        } else {
            const data = {
                option_name:  'type_assignments',
                option_value: JSON.stringify(assignments)
            };
            console.log('TypeAssignments::save',data);
            supportAPI.post(`/options/`, data).then(() => {
                console.log('Type Assignments saved');
                setSaveConfirm(true);
            }).catch(err => console.error(err));
        }
    }

    return (
        <div className="wrap">
            {!agentList
                ? `Loading agents...`
                : <>
                    <h3>Assign ticket types</h3>
                    <p>Tickets with these types will auto-assign to these agents unless the company has its own
                        overrides.</p>

                    {types.defaults.map(type => {
                        const key = type.name.toLowerCase().replace(/[^a-z]/g, '_');
                        return (
                            <div key={key} className="d-flex flex-nowrap flex-row" style={{lineHeight: '35px'}}>
                                <strong className="me-2 text-nowrap" style={{minWidth: '150px'}}>{type.name}:</strong>
                                <SelectorInput
                                    inputClass="mb-3"
                                    inputInstructions="Assign to..."
                                    inputName="assignee_id"
                                    inputValue={assignments[key] || ''}
                                    inputOptions={getOptions()}
                                    onChange={(value) => handleChange(key, value)}
                                />
                            </div>
                        );
                    })}
                    <div className={'d-flex justify-content-center align-items-center'}>
                        {saveConfirm ? <i className={'bi bi-check fs-4 text-success'} /> : null}
                        <button
                            className={`btn btn-success d-block`}
                            onClick={handleSubmit}
                        >Save Assignments
                        </button>
                    </div>
                </>
            }
        </div>
    );
};

export default TypeAssignments;